import React, { Component } from 'react';
import './Tabs.css';
import { uniq } from 'lodash'
import { Link } from 'react-router-dom';


class Tabs extends Component {
    constructor(props) {
        super(props);
        this.state = {
            core: '',
            augmentProduct: '',
            services: '',
            intPartnership: '',
        };
    }
    onChange = (name, value) => {
        if (name === "core") {
            this.setState({
                core: value
            })
        }
        if (name === "augmentProduct") {
            this.setState({
                augmentProduct: value
            })
        }
        if (name === "services") {
            this.setState({
                services: value
            })
        }
        if (name === "intPartnership") {
            this.setState({
                intPartnership: value
            })
        }
    }
    onAdd = (groupId, segmentId, name) => {
        if (name === "core" && this.state.core) {
            this.props.onAdd(groupId, segmentId, name, this.state.core)
            this.setState({ core: '' })
        }
        if (name === "augmentProduct" && this.state.augmentProduct) {
            this.props.onAdd(groupId, segmentId, name, this.state.augmentProduct)
            this.setState({ augmentProduct: '' })
        }
        if (name === "services" && this.state.services) {
            this.props.onAdd(groupId, segmentId, name, this.state.services)
            this.setState({ services: '' })
        }
        if (name === "intPartnership" && this.state.intPartnership) {
            this.props.onAdd(groupId, segmentId, name, this.state.intPartnership)
            this.setState({ intPartnership: '' })
        }
    }
    render() {
        let tabs = []
        this.props.tabs.map((item, key) => {
            this.props.compete.customerSegmentData.map(comp => {
                comp.segments.map(segments => {
                    if (item.groupId === comp.groupId && item.segmentId === segments.segmentId) {
                        tabs.push(
                            <li className="nav-item" key={`${item.groupId + `id` + item.segmentId}`} onClick={()=>this.props.onTabChange(key)}>
                                <a data-toggle="tab" className={key === this.props.tabStep ? "nav-link active show" : "nav-link"} href={`#${item.groupId + `id` + item.segmentId}`} aria-controls={`${item.groupId + `id` + item.segmentId}`} aria-selected="true">{comp.groupName + ` - ` + segments.name} <i className="fa fa-minus minus-icon"
                                    onClick={() => this.props.onDelete(item.groupId, item.segmentId)}
                                ></i></a>
                            </li>)
                    }
                })
            })

        });
        let tabsContent = this.props.tabs.map((tabItem, key) => {
            return (
                <div id={tabItem.groupId + `id` + tabItem.segmentId} className={key === this.props.tabStep ? "tab-pane fade show active tabContentdiv positioning-tab-content" : "tab-pane fade tabContentdiv compete-tab-content positioning-tab-content"} role="tabpanel" key={key}>
                    <div className="row">
                        <div className="col-md-12" style={{marginBottom: "15px"}}>
                            <Link to={`/positioning-statement/${this.props.projectId}`}>Review your Positioning Statement</Link>
                        </div>
                        <div className="col-md-12">
                            <div className="row">
                                <div className="col-md-12">
                                    <div className="row" style={{ borderBottom: "1px solid #ddd", marginBottom: "10px" }}>
                                        <div className="col-lg-6">
                                            <div className="row">
                                                <div className="col-md-4">Core:</div>
                                                <div className="col-md-8">
                                                    <div className="row">
                                                        <div className="col-md-10">
                                                            <div className="form-group">
                                                                <input
                                                                    type="text"
                                                                    className="form-control"
                                                                    value={this.state.core}
                                                                    onChange={(e) => this.onChange("core", e.target.value)}
                                                                    onKeyPress={(e) => { e.key === "Enter" && this.onAdd(tabItem.groupId, tabItem.segmentId, "core") }}
                                                                />
                                                            </div>
                                                        </div>
                                                        <div className="col-md-1">
                                                            <i className="fa fa-plus plusbtn plus-icon" onClick={() => this.onAdd(tabItem.groupId, tabItem.segmentId, "core")}></i>
                                                        </div>
                                                    </div>
                                                </div>
                                                {tabItem.product && tabItem.product.offer && tabItem.product.offer.core.length > 0 &&
                                                    tabItem.product.offer.core.map((core, key) => {
                                                        return <div className="col-md-12" key={key}>
                                                            <div className="promotionValues">
                                                                <label >{core}</label>
                                                                <i className="fa fa-minus minus-icon" onClick={() => this.props.onDeleteCore(tabItem.groupId, tabItem.segmentId, core)}></i>
                                                            </div>
                                                        </div>
                                                    })
                                                }
                                            </div>
                                        </div>
                                        {
                                            this.props.tabs.map(tab => {
                                                if (tab.groupId === tabItem.groupId && tab.segmentId !== tabItem.segmentId) {
                                                    return <div className="col-md-2">
                                                        <div className="row" style={{borderLeft: "1px solid #ddd"}}>
                                                            <div className="col-md-12" style={{ textAlign: "center" }}>
                                                                {
                                                                    this.props.compete.customerSegmentData.map(item => {
                                                                        if (item.groupId === tab.groupId) {
                                                                            return item.segments.map(segment => {
                                                                                if (segment.segmentId === tab.segmentId) {
                                                                                    return <span style={{ fontWeight: "bold" }}>{segment.name}</span>
                                                                                }
                                                                            })
                                                                        }
                                                                    })
                                                                }
                                                            </div>
                                                            {tab.product.offer.core.map(item => {
                                                                return <div className="col-md-12">
                                                                    <div className="form-group">
                                                                        <input
                                                                            type="text"
                                                                            className="form-control"
                                                                            disabled
                                                                            value={item}
                                                                        />
                                                                    </div>
                                                                </div>
                                                            })}
                                                        </div>
                                                    </div>
                                                }
                                            })
                                        }
                                    </div>
                                </div>

                                <div className="col-md-12">
                                    <div className="row" style={{ borderBottom: "1px solid #ddd", marginBottom: "10px" }}>
                                        <div className="col-lg-6">
                                            <div className="row">
                                                <div className="col-md-4">Augmented Product:</div>
                                                <div className="col-md-8">
                                                    <div className="row">
                                                        <div className="col-md-10">
                                                            <div className="form-group">
                                                                <input
                                                                    type="text"
                                                                    className="form-control"
                                                                    value={this.state.augmentProduct}
                                                                    onChange={(e) => this.onChange("augmentProduct", e.target.value)}
                                                                    onKeyPress={(e) => { e.key === "Enter" && this.onAdd(tabItem.groupId, tabItem.segmentId, "augmentProduct") }}
                                                                />
                                                            </div>
                                                        </div>
                                                        <div className="col-md-1">
                                                            <i className="fa fa-plus plusbtn plus-icon" onClick={() => this.onAdd(tabItem.groupId, tabItem.segmentId, "augmentProduct")}></i>
                                                        </div>
                                                    </div>
                                                </div>
                                                {tabItem.product && tabItem.product.offer && tabItem.product.offer.augmentProduct.length > 0 &&
                                                    tabItem.product.offer.augmentProduct.map((augmentProduct, key) => {
                                                        return <div className="col-md-12" key={key}>
                                                            <div className="promotionValues">
                                                                <label >{augmentProduct}</label>
                                                                <i className="fa fa-minus minus-icon" onClick={() => this.props.onDeleteAugmentProduct(tabItem.groupId, tabItem.segmentId, augmentProduct)}></i>
                                                            </div>
                                                        </div>
                                                    })
                                                }
                                            </div>
                                        </div>

                                        {
                                            this.props.tabs.map(tab => {
                                                if (tab.groupId === tabItem.groupId && tab.segmentId !== tabItem.segmentId) {
                                                    return <div className="col-md-2">
                                                        <div className="row" style={{borderLeft: "1px solid #ddd"}}>
                                                            {tab.product.offer.augmentProduct.map(item => {
                                                                return <div className="col-md-12">
                                                                    <div className="form-group">
                                                                        <input
                                                                            type="text"
                                                                            className="form-control"
                                                                            disabled
                                                                            value={item}
                                                                        />
                                                                    </div>
                                                                </div>
                                                            })}
                                                        </div>
                                                    </div>
                                                }
                                            })
                                        }
                                    </div>
                                </div>

                                <div className="col-md-12">
                                    <div className="row" style={{ borderBottom: "1px solid #ddd", marginBottom: "10px" }}>
                                        <div className="col-lg-6">
                                            <div className="row">
                                                <div className="col-md-4">Services:</div>
                                                <div className="col-md-8">
                                                    <div className="row">
                                                        <div className="col-md-10">
                                                            <div className="form-group">
                                                                <input
                                                                    type="text"
                                                                    className="form-control"
                                                                    value={this.state.services}
                                                                    onChange={(e) => this.onChange("services", e.target.value)}
                                                                    onKeyPress={(e) => { e.key === "Enter" && this.onAdd(tabItem.groupId, tabItem.segmentId, "services") }}
                                                                />
                                                            </div>
                                                        </div>
                                                        <div className="col-md-1">
                                                            <i className="fa fa-plus plusbtn plus-icon" onClick={() => this.onAdd(tabItem.groupId, tabItem.segmentId, "services")}></i>
                                                        </div>
                                                    </div>
                                                </div>
                                                {tabItem.product && tabItem.product.offer && tabItem.product.offer.services.length > 0 &&
                                                    tabItem.product.offer.services.map((services, key) => {
                                                        return <div className="col-md-12" key={key}>
                                                            <div className="promotionValues">
                                                                <label >{services}</label>
                                                                <i className="fa fa-minus minus-icon" onClick={() => this.props.onDeleteServices(tabItem.groupId, tabItem.segmentId, services)}></i>
                                                            </div>
                                                        </div>
                                                    })
                                                }
                                            </div>
                                        </div>

                                        {
                                            this.props.tabs.map(tab => {
                                                if (tab.groupId === tabItem.groupId && tab.segmentId !== tabItem.segmentId) {
                                                    return <div className="col-md-2">
                                                        <div className="row" style={{borderLeft: "1px solid #ddd"}}>
                                                            {tab.product.offer.services.map(item => {
                                                                return <div className="col-md-12">
                                                                    <div className="form-group">
                                                                        <input
                                                                            type="text"
                                                                            className="form-control"
                                                                            disabled
                                                                            value={item}
                                                                        />
                                                                    </div>
                                                                </div>
                                                            })}
                                                        </div>
                                                    </div>
                                                }
                                            })
                                        }
                                    </div>
                                </div>



                                <div className="col-md-12">
                                    <div className="row">
                                        <div className="col-lg-6">
                                            <div className="row">
                                                <div className="col-md-4">Information and Consulting</div>
                                                <div className="col-md-8">
                                                    <div className="row">
                                                        <div className="col-md-10">
                                                            <div className="form-group">
                                                                <input
                                                                    type="text"
                                                                    className="form-control"
                                                                    value={this.state.intPartnership}
                                                                    onChange={(e) => this.onChange("intPartnership", e.target.value)}
                                                                    onKeyPress={(e) => { e.key === "Enter" && this.onAdd(tabItem.groupId, tabItem.segmentId, "intPartnership") }}
                                                                />
                                                            </div>
                                                        </div>
                                                        <div className="col-md-1">
                                                            <i className="fa fa-plus plusbtn plus-icon" onClick={() => this.onAdd(tabItem.groupId, tabItem.segmentId, "intPartnership")}></i>
                                                        </div>
                                                    </div>
                                                </div>
                                                {tabItem.product && tabItem.product.offer && tabItem.product.offer.intPartnership.length > 0 &&
                                                    tabItem.product.offer.intPartnership.map((intPartnership, key) => {
                                                        return <div className="col-md-12" key={key}>
                                                            <div className="promotionValues">
                                                                <label >{intPartnership}</label>
                                                                <i className="fa fa-minus minus-icon" onClick={() => this.props.onDeleteIntPartnership(tabItem.groupId, tabItem.segmentId, intPartnership)}></i>
                                                            </div>
                                                        </div>
                                                    })
                                                }
                                            </div>
                                        </div>
                                        {
                                            this.props.tabs.map(tab => {
                                                if (tab.groupId === tabItem.groupId && tab.segmentId !== tabItem.segmentId) {
                                                    return <div className="col-md-2">
                                                        <div className="row" style={{borderLeft: "1px solid #ddd"}}>
                                                            {tab.product.offer.intPartnership.map(item => {
                                                                return <div className="col-md-12">
                                                                    <div className="form-group">
                                                                        <input
                                                                            type="text"
                                                                            className="form-control"
                                                                            disabled
                                                                            value={item}
                                                                        />
                                                                    </div>
                                                                </div>
                                                            })}
                                                        </div>
                                                    </div>
                                                }
                                            })
                                        }
                                    </div>
                                </div>

                            </div>
                        </div>
                    </div >
                </div >
            )

        })
        return (
            <div className='criteria-tabs-content attractiveness-tab-content' >
                <ul className="nav nav-tabs benefitsNavTabs" role="tablist" id="myTab">
                    <li className="nav-item">
                        <a id='plusTab' onClick={() => this.props.createTabModal()}
                        ><i className="fa fa-plus plusbtn plus-icon"></i></a>
                    </li>
                    {tabs}
                </ul>
                <div className="tab-content benefitsTabcontent" id="myTabContent" >
                    {tabsContent}
                </div>
            </div>
        )
    }
}

export default (Tabs);



// WEBPACK FOOTER //
// ./src/components/ValuePropositionComponent/Step1/Tabs/Tabs.jsx